export const enum FaqKeywordFlags {
	ADD = 1,
	EDIT = 1 << 2,
	VIEW = 1 << 3,
	AUDIT = 1 << 4,
}
export type FaqKeywordFlagsType = keyof typeof FaqKeywordFlags
export type FaqKeywordFlagsValue = typeof FaqKeywordFlags[FaqKeywordFlagsType]

export enum FaqKeywordStatus {
	'启用' = 'enable',
	'禁用' = 'disable',
}

export type FaqKeywordStatusType = keyof typeof FaqKeywordStatus
export type FaqKeywordStatusValue = typeof FaqKeywordStatus[FaqKeywordStatusType]

export enum FaqKeywordType {
	'公共' = 'public',
	'个人' = 'private',
}

export type FaqKeywordTypeType = keyof typeof FaqKeywordType
export type FaqKeywordTypeValue = typeof FaqKeywordType[FaqKeywordTypeType]
